import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/pubs/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("pubs", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/pubs/${params.slug}`, locale: "en", loaderData }),
  component: PubsPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Pub not available</h1>
        <Link to="/pubs" className="mt-6 inline-block text-royal underline">
          Browse all pubs
        </Link>
      </div>
    </div>
  ),
});

function PubsPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="pubs" placeSlug={slug} locale="en" />;
}
